/**
 * The in-app route a modal was opened from, or null when it was entered by a
 * document load.
 *
 * Closing a modal opened by an in-app push can go back through the router, because
 * the origin page is still in memory. A modal reached by document load has no such
 * page to return to — the SPA never re-hydrates Gutenberg content client-side — so
 * it has to fall back to a document navigation.
 *
 * Distinct from router.js's eventModalOrigin, which answers a narrower question for
 * one route and rebuilds the calendar's query from window.location. Before adding a
 * third tracker, fold it into one of these two.
 */
let origin = null;

export function setSpaModalOrigin(value) {
  origin = value;
}

export function spaModalOrigin() {
  return origin;
}
